import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const temas = [
  "Pensamientos que no puedes apagar.",
  "Hiperfocos, ideas y nuevos descubrimientos.",
  "Dificultades con la atención y la ejecución.",
  "Sensibilidad emocional o sensorial.",
  "Relaciones, trabajo y sensación de no encajar.",
  "Momentos de bloqueo o sobrecarga.",
  "Reflexiones profundas que quieres explorar.",
  "Pequeñas victorias que tu entorno quizá no comprendería.",
  "Conversaciones espontáneas sobre cualquier tema que interese a los miembros.",
];

export const Compartir = () => (
  <section className="bg-[#0E1628] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <Reveal>
        <ChapterLabel number="03" testId="chapter-compartir" />
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Todo eso que normalmente se queda dentro.
        </h2>
      </Reveal>

      <div className="mt-12 flex max-w-4xl flex-wrap gap-3" data-testid="compartir-topics">
        {temas.map((tema, i) => (
          <Reveal key={tema} delay={0.03 * i}>
            <span className="inline-block rounded-full border border-[#22304D] bg-[#131D33] px-5 py-2.5 text-sm leading-snug text-[#E8E4DC] transition-colors hover:border-[#8B7CF6]/40">
              {tema}
            </span>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 max-w-2xl text-sm leading-relaxed text-[#9AA6BE] md:text-base">
          Puedes participar activamente o simplemente leer hasta sentirte
          cómodo. Nadie te va a exigir intervenir: este espacio también es para
          quienes necesitan observar primero.
        </p>
      </Reveal>
    </div>
  </section>
);
